import { render, staticRenderFns } from "./CategoriasRedes.vue?vue&type=template&id=5ce22cb8&scoped=true"
import script from "./CategoriasRedes.vue?vue&type=script&lang=js"
export * from "./CategoriasRedes.vue?vue&type=script&lang=js"
import style0 from "./CategoriasRedes.vue?vue&type=style&index=0&id=5ce22cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce22cb8",
  null
  
)

export default component.exports